import { render, staticRenderFns } from "./center-settings.vue?vue&type=template&id=53d0a632&scoped=true&"
import script from "./center-settings.ts?vue&type=script&lang=ts&"
export * from "./center-settings.ts?vue&type=script&lang=ts&"
import style0 from "./center-settings.scss?vue&type=style&index=0&id=53d0a632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d0a632",
  null
  
)

export default component.exports